import davidSides from "../components/courseOverview/courseTeachers/img/david-sides.png";
import philAnderson from "../components/courseOverview/courseTeachers/img/phil-anderson.png";
import wiChen from "../components/courseOverview/courseTeachers/img/wi-chen.png";
import theronBrown from "../components/courseOverview/courseTeachers/img/theron-brown.png";
import amySauriol from "../components/courseOverview/courseTeachers/img/amy-sauriol.png";
import mikeGarson from "../components/courseOverview/courseTeachers/img/mike-garson.png";

export interface ICourseOverviewTeacher {
  teacherImgUrl: string;
  teacherName: "David Sides" | "Phil Anderson" | "Wi Chen" | "Mike Garson" | "Theron Brown" | "Amy Sauriol";
}

export interface ICourseOverviewLessonFeatures {
  hasInteractiveNotation?: boolean;
  hasVideo?: boolean;
}

export interface ICourseOverview {
  id: number;
  summary: string;
  lessonFeatures?: ICourseOverviewLessonFeatures;
  organizationMethod: string;
  teachers?: [ICourseOverviewTeacher, ...ICourseOverviewTeacher[]];
  topics?: [string, ...string[]];
  recommendedPreparation?: string[];
}

export const courseOverviewConfig: Record<number, ICourseOverview> = {
  35: {
    id: 35,
    summary: "Ground zero. Designed for users with no musical experience, this section of the Bootcamp will hold your hand while you learn music's fundamentals — including naming the keys on your keyboard, reading music, and playing whole, half, and quarter notes with both hands. As you move through the Rookie Bootcamp Tour, you'll be building up the skills needed to begin to play your favorite songs.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: davidSides,
      teacherName: "David Sides",
    },
    {
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },
    ],
    topics: ["The fingering system",
      "The musical alphabet",
      "Basic rhythms",
      "The fundamentals of reading music",
      "How to play with both hands",
      "How to play scales",],
    recommendedPreparation: ["No prior musical knowledge needed",],
  },
  36: {
    id: 36,
    summary: "The Intermediate Bootcamp Tour picks up where the Rookie Bootcamp Tour leaves off, building on the fundamentals and introducing you to the world of chords and their critical role in creating harmony. You'll also learn how to play with 8th notes, more complex rhythms, and other Intermediate-level skills to help you bring your music to life.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true,
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: davidSides,
      teacherName: "David Sides",
    },
    {
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },
    ],
    topics: ["How to build and play chords",
      "Major vs minor chords",
      "Block chords & broken chords",
      "Chord inversions",
      "Chord progressions",
      "Reading chords in notation",
      "Intermediate rhythms",],
    recommendedPreparation: ["How to play basic rhythms",
      "How to play with both hands",
      "The fundamentals of reading music",],
  },
  37: {
    id: 37,
    summary: "The Advanced Bootcamp Tour is the final stage of the Bootcamp learning path, building on the skills you've accumulated from the Rookie and Intermediate Bootcamp Tours. Here you'll learn to play advanced rhythms, including 16th notes, and dive into specialized topics including complex voicings, arpeggios, and much more. After completing the Advanced Bootcamp Tour, you'll be equipped with the skills and knowledge to play any song in our song library, as well as improvise and even create your own songs.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: davidSides,
      teacherName: "David Sides",
    },
    ],
    topics: ["Advanced rhythms",
      "Complex voicings",
      "Arpeggios",
      "7th chords",
      "Parallel octaves",],
    recommendedPreparation: ["The fundamentals of reading music",
      "How to play 8th notes",
      "How to play block & broken chords",
      "How to play chord inversions",],
  },
  29: {
    id: 29,
    summary: "From “Für Elise” to “Rocket Man”, this course provides beginners with fun practice playing songs with their right hand. These songs are arranged so you don't have to move your hand, allowing you to more easily play and experience some of the most famous melodies of all time.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: false
    },
    organizationMethod: "Easiest to hardest",
    topics: ["Famous pop, rock, film, classical, and jazz melodies",],
    recommendedPreparation: ["The fingering system",],
  },
  39: {
    id: 39,
    summary: "An introduction to scales, this course contains 26 major and minor scales, organized by key signature, to be played with both hands within the range of 1 octave. Practicing scales is a great way to warm up, build hand dexterity, get used to playing different keys (no pun intended), and ultimately help you learn songs more quickly.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Easiest to hardest",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    }
    ],
    topics: ["How to play 13 major scales with both hands, across 1 octave",
      "How to play 13 natural minor scales with both hands, across 1 octave",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  45: {
    id: 45,
    summary: `This intermediate course builds upon our foundational 1 Octave Scales course by delving into 26 major and minor scales across 2 octaves, broadening your range and introducing more complex hand movements. Each major scale is paired with its relative natural minor, ordered by key signature to facilitate a comprehensive understanding of tonal relationships. Ideal for warm-ups, it boosts hand coordination and agility. As you master these scales, you'll not only enhance your keyboard familiarity and technical prowess but also accelerate your ability to learn new songs.`,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true,
    },
    organizationMethod: "Easiest to hardest",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    }
    ],
    topics: ["How to play 13 major and 13 natural minor scales with both hands across 2 octaves"],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "Practice playing one octave scales"],
  },
  19: {
    id: 19,
    summary: "Designed for beginners or anyone looking to get more practice playing music with both hands, this course consists of 40 songs that are sure to get those hands playing together like an orchestra.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: false
    },
    organizationMethod: "Easiest to hardest",
    topics: ["Simple melodies from a variety of popular songs",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  40: {
    id: 40,
    summary: "The ultimate destination for practicing chords, this course contains lessons designed to help play and transition between 24 different chords in root position, 1st inversion, and 2nd inversion triads. You'll also get more practice using chord symbols as you play through popular chord progressions. By the time you complete this course, you'll be a chord master, ready to rock any power ballad that comes your way.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Easiest to hardest",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },
    ],
    topics: ["Practice playing root position and chord inversions across 12 major and 12 minor keys",
      "Practice transitioning between chords quickly",
      "Practice reading chord symbols",
      "Practice reading chords in notation",],
    recommendedPreparation: ["How to play basic rhythms",
      "Some experience playing chords",],
  },
  58: {
    id: 58,
    summary: "From lines & spaces, to the Grand Staff — this course provides extra practice for reading and playing notes in sheet music. It's perfect for anyone looking to improve their reading skills.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["How to read notes on the Treble Staff",
      "How to read notes on the Bass Staff",
      "How to read notes on a Grand Staff",
      "How to read notes on ledger lines",
      "How to read accidentals",
      "How to read notes using the Key Signature",],
    recommendedPreparation: ["The letter names of notes",
      "How to play with both hands",],
  },
  79: {
    id: 79,
    summary: "Want to improve your hand dexterity, finger independence, and strengthen your fingers? Look no further than this course which contains the first 20 exercises from one of the most popular technique books ever created: “Hanon — The Virtuoso Pianist.” It's guaranteed to make your fingers so agile and fast, they may require insurance.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Any order",
    teachers: [{
      teacherImgUrl: wiChen,
      teacherName: "Wi Chen",
    },],
    topics: ["Practice exercises for finger strength",
      "Practice exercises for finger stamina",
      "Practice exercises for finger dexterity",
      "Practice exercises for finger speed",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "How to pivot with each hand",]
  },
  106: {
    id: 106,
    summary: "Part of our Community Challenge Series, this course, designed for young kids, teaches sections of a Rookie version of Josh Groban's “You Raise Me Up” across 4 days of lessons. By the end of this course, you'll be playing various sections of the pop classic.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["Various sections of Josh Groban's song, “You Raise Me Up”",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  103: {
    id: 103,
    summary: "Part of our Community Challenge Series, this course teaches sections of a Rookie version of Josh Groban's “You Raise Me Up” across 12 days of lessons. By the end of this course, you'll be playing various sections of the pop classic.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["Various sections of Josh Groban's song, “You Raise Me Up”",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  104: {
    id: 104,
    summary: "Part of our Community Challenge Series, this course teaches sections of an Intermediate version of Josh Groban's “You Raise Me Up” across 20 days of lessons. By the end of this course, you'll be playing various sections of the pop classic.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["Various sections of Josh Groban's song, “You Raise Me Up”",
      "The melody and chords of the song",],
    recommendedPreparation: ["How to play basic rhythms",
      "The fundamentals of reading music",],
  },
  111: {
    id: 111,
    summary: "Part of our Community Challenge Series, this course teaches sections of an Advanced version of Josh Groban's “You Raise Me Up” across 13 days of lessons. By the end of this course, you'll be playing various sections of the pop classic.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["Various sections of Josh Groban's song, “You Raise Me Up”",],
    recommendedPreparation: ["How to read accidentals",
      "How to play block chords in different inversions",
      "How to play broken chords",
      "How to play octaves",],
  },
  122: {
    id: 122,
    summary: "Part of our Community Challenge Series, this course features one of the most beautiful piano pieces ever written. Designed for all levels, it contains a mix of Rookie and Intermediate / Advanced lessons teaching the original arrangement of Bach's “Prelude In C” through step-by-step lessons that are sure to make the song fun and easy to learn. By the end of this course, you'll be playing the famous classical piece.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["An arrangement of Bach's classic, “Prelude In C”",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  152: {
    id: 152,
    summary: "Part of our Community Challenge Series, this course teaches how to accompany a singer while playing the piano. The song played in this course features the beautiful voice of Sheléa in her hit song “Grace,” and is taught across 18 days of lessons. Through Sheléa’s voice, this song also carries a rich and empowering message that's sure to inspire. By the end of this course, you’ll be playing the entire song along with Sheléa!",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["A Rookie arrangement of Sheléa's song, “Grace”",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  153: {
    id: 153,
    summary: "Part of our Community Challenge Series, this course teaches how to accompany a singer while playing the piano. The song played in this course features the beautiful voice of Sheléa in her hit song, “Grace,” and is taught across 26 days of lessons. Through Sheléa’s voice, the song also carries a rich and empowering message that's sure to inspire. By the end of this course, you’ll be playing the entire song along with Sheléa!",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["An Intermediate arrangement of Sheléa's song, “Grace”",
      "How to play chords with your right hand",
      "How to accompany a singer",],
    recommendedPreparation: ["How to play basic rhythms",
      "The fundamentals of reading music",],
  },
  154: {
    id: 154,
    summary: "Part of our Community Challenge Series, this course teaches how to accompany a singer while playing the piano. The song played in this course features the beautiful voice of Sheléa in her hit song, “Grace,” and is taught across 19 days of lessons. Through Sheléa’s voice, the song also carries a rich and empowering message that's sure to inspire. By the end of this course, you’ll be playing the entire song along with Sheléa!",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["An Advanced arrangement of Sheléa's song, “Grace”",
      "How to play chords with your right hand",
      "How to accompany a singer",],
    recommendedPreparation: ["The fundamentals of reading music",
      "How to play block chords in different inversions",
      "How to play broken chords",
      "How to play octaves",
      "Experience playing accidentals",],
  },
  214: {
    id: 214,
    summary: "In this course, Mike Garson — David Bowie's Piano Man for over 600 concerts and 20 albums — gives an insider’s look into the power of the piano, covering lessons on performance and stage fright, playing as a solo pianist vs accompanist, The Blues & Boogie Woogie, the importance of technique, and much more. He also breaks down some of his favorite songs, including “Life on Mars?” and “Heroes” by David Bowie, “So What” by Miles Davis, and “Canon in D” by Pachelbel.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Any order",
    teachers: [{
      teacherImgUrl: mikeGarson,
      teacherName: "Mike Garson",
    },],
    topics: ["Playing with intention & expression",
      "Soloist style vs accompanist style",
      "Performance & stage fright",
      "The importance of technique",
      "The blues & boogie woogie",
      "Some of David Bowie's favorite songs",],
    recommendedPreparation: ["No prior musical knowledge needed to understand the video lessons",
      "Playing the song examples requires Intermediate level experience",],
  },
  186: {
    id: 186,
    summary: "Featuring hits like “Lean On Me,” “My Way,” and more, this Playlist features a collection of fun, easy, and recognizable songs to play during your first week of piano lessons, even if you're brand new to the piano. All songs feature step-by-step guided video lessons.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Any order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },
    {
      teacherImgUrl: theronBrown,
      teacherName: "Theron Brown",
    },],
    topics: ["Simple melodies from a variety of popular songs",],
    recommendedPreparation: ["No prior musical knowledge needed",],
  },
  200: {
    id: 200,
    summary: "This Playlist contains some of our easiest songs to play, featuring popular short songs designed for Rookie players who are just starting out, or anyone looking to brush up on their song-playing skills. Short songs include a few of the most popular song sections, such as the intro, verse, and chorus. Some songs contain multiple arrangement difficulty levels.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Any order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },
    {
      teacherImgUrl: theronBrown,
      teacherName: "Theron Brown",
    },
    {
      teacherImgUrl: amySauriol,
      teacherName: "Amy Sauriol",
    },],
    topics: ["A variety of popular Rookie short songs",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  90: {
    id: 90,
    summary: "Part of our Community Challenge Series, this course teaches a Rookie version of Scott Joplin's hit, “The Entertainer,” across 30 days of lessons. This groundbreaking song's simple yet iconic sound is broken down-step-by-step, making it easy and fun to play. By the end of this course, you'll be playing the first section of the famous ragtime classic.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["The first section of the Scott Joplin's hit, “The Entertainer,” arranged at a Rookie level",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  165: {
    id: 165,
    summary: "Part of our Community Challenge Series, this course teaches a Rookie version of one of the most famous classical pieces of all time, Beethoven's “Für Elise,” across 6 days of lessons. This song's fun and beautiful melody is one that's sure to impress. By the end of this course, you'll be playing the iconic music of a classical classic.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["A Rookie version of Beethoven's classic, “Für Elise”",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  129: {
    id: 129,
    summary: "Part of our Community Challenge Series, this course teaches a fun and memorable Rookie arrangement of a Holiday Medley consisting of “Joy To The World”, “Jingle Bells”, and “Hark! The Herald Angels Sing.” This challenge is as joyous as the holiday season itself.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: davidSides,
      teacherName: "David Sides",
    },
    {
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["A Rookie medley consisting of “Joy To The World,” “Jingle Bells,” and “Hark! The Herald Angels Sing.”",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  209: {
    id: 209,
    summary: "Part of our Community Challenge Series, this course teaches how to play the Rookie level of the beautiful holiday classic, “Angels We Have Heard On High.”",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["A Rookie arrangement of “Angels We Have Heard On High”",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  100: {
    id: 100,
    summary: "This course contains a selection of fun songs for kids to play.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: false
    },
    organizationMethod: "Any order",
    topics: ["Sections from a variety of popular songs",],
    recommendedPreparation: ["The fingering system",],
  },
  205: {
    id: 205,
    summary: "This Playlist features an assortment of popular short songs designed for Intermediate players. Songs in this playlist consist of only a few of the most popular sections, such as the intro, verse, and chorus — and are some of our easiest Intermediate arrangements, making them a great way for Rookie and freshly minted Intermediate players to ease into Intermediate songs.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: false
    },
    organizationMethod: "Any order",
    topics: ["A variety of popular Intermediate short songs",],
    recommendedPreparation: ["How to play basic rhythms",
      "Some experience playing chords",],
  },
  142: {
    id: 142,
    summary: "Part of our Community Challenge Series, this course teaches an Intermediate version of Scott Joplin's “The Entertainer” across 18 days of lessons. This groundbreaking song's simple yet iconic sound is broken down step-by-step, making it easy and fun to play. By the end of this course, you'll be playing the first section of the famous ragtime classic.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["The first section of the Scott Joplin's hit, “The Entertainer,” arranged at an Intermediate level.",
      "The melody and chords of the song",],
    recommendedPreparation: ["How to play basic rhythms",
      "The fundamentals of reading music",],
  },
  166: {
    id: 166,
    summary: "Part of our Community Challenge Series, this course teaches an Intermediate version of one of the most famous classical pieces of all time, Beethoven's ”Für Elise,” across 6 days of lessons. This song's fun and beautiful melody is one that's sure to impress. By the end of this course, you'll be playing the iconic music of a classical classic.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["An Intermediate version of Beethoven's classic, ”Für Elise”",
      "The melody and chords of the song",],
    recommendedPreparation: ["How to play basic rhythms",
      "The fundamentals of reading music",],
  },
  130: {
    id: 130,
    summary: "Part of our Community Challenge Series, this course teaches a fun and memorable Intermediate arrangement of a Holiday Medley consisting of “Joy To The World”, “Jingle Bells”, and “Hark! The Herald Angels Sing.” This challenge is as joyous as the holiday season itself.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: davidSides,
      teacherName: "David Sides",
    },
    {
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["An Intermediate medley consisting of “Joy To The World,” “Jingle Bells,” and “Hark! The Herald Angels Sing.”",],
    recommendedPreparation: ["How to play basic rhythms",
      "The fundamentals of reading music",],
  },
  210: {
    id: 210,
    summary: "Part of our Community Challenge Series, this course teaches how to play the Intermediate level of the beautiful holiday classic, “Angels We Have Heard On High.”",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["An Intermediate arrangement of “Angels We Have Heard On High”",],
    recommendedPreparation: ["How to play basic rhythms",
      "The fundamentals of reading music",],
  },
  131: {
    id: 131,
    summary: "Part of our Community Challenge Series, this course teaches a fun and memorable Advanced arrangement of a Holiday Medley consisting of “Joy To The World”, “Jingle Bells”, and “Hark! The Herald Angels Sing.” This challenge is as joyous as the holiday season itself.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["An Advanced medley consisting of “Joy To The World,” “Jingle Bells,” and “Hark! The Herald Angels Sing.”",],
    recommendedPreparation: ["The fundamentals of reading music",
      "How to play block chords in different inversions",
      "How to play broken chords",
      "How to play octaves",
      "Experience playing accidentals",],
  },
  207: {
    id: 207,
    summary: "Part of our Community Challenge Series, this course teaches how to play the Advanced level of the beautiful holiday classic, “Angels We Have Heard On High.”",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["An Advanced arrangement of “Angels We Have Heard On High”",],
    recommendedPreparation: ["The fundamentals of reading music",
      "How to play block chords",
      "How to play broken chords",
      "Experience playing accidentals",],
  },
  187: {
    id: 187,
    summary: "This Playlist is a collection of songs that are arranged to be played in the style of a piano accompanist. The accompanist style is when a pianist only plays the harmonies of a song leaving room for the melody to be sung or played by a different instrument (like a violin).",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Any order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["A variety of popular accompaniment style songs",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music",],
  },
  192: {
    id: 192,
    summary: "“Imagine”, “Halo”, “In The End”, “Clocks”, and many more — this Playlist teaches how to play some of the most iconic piano riffs of all-time across various eras and genres, through a mixture of video and interactive notation lessons.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Any order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },
    {
      teacherImgUrl: theronBrown,
      teacherName: "Theron Brown",
    },
    {
      teacherImgUrl: amySauriol,
      teacherName: "Amy Sauriol",
    },],
    topics: ["A variety of popular piano \"Riffs",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music",],
  },
  80: {
    id: 80,
    summary: "Part of our Community Challenge Series, this course teaches how to play an Advanced arrangement of Eli Teplin's “Writing On The Wall” across 5 lessons. By the end of this course, you'll be playing the entire song.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },],
    topics: ["An arrangement of Eli Teplin's song, “Writing On The Wall”",
      "How to accompany a singer",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music",],
  },
  63: {
    id: 63,
    summary: "This course contains a selection of fun songs for our Playground Community.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: false
    },
    organizationMethod: "Any order",
    topics: ["Sections from a variety of popular songs",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music",],
  },
  184: {
    id: 184,
    summary: "Part of our Community Challenge Series, this course provides a sampling of content featured in Bootcamps, Courses, and Songs — curated by the Playground Sessions team.",
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Any order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    },
    {
      teacherImgUrl: wiChen,
      teacherName: "Wi Chen",
    },],
    topics: ["A selection of Bootcamp lessons, Course lessons, and songs",],
    recommendedPreparation: ["The fingering system",
      "How to play with both hands",
      "The fundamentals of reading music with both hands",],
  },
  215: {
    id: 215,
    summary: `This course explores classical music's rich history and influence on modern music. Beginning with the Baroque era and progressing through the Classical, Romantic, Impressionism, and Modern eras, you will learn about notable composers and play famous pieces from each era, including Bach's “Prelude in C,” Beethoven's “Moonlight Sonata,” and Joplin's “Maple Leaf Rag.” Piano techniques used in each era, such as pedaling, exotic scales, articulation, and more will be taught. This course is for anyone interested in playing Classical music, or learning about its history and connection to music today.`,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: amySauriol,
      teacherName: "Amy Sauriol",
    }],
    topics: ["Key composers: Bach, Mozart, Beethoven, Chopin, Debussy, Joplin, and Bartók",
      "The Baroque, Classical, Romantic, Impressionism, and Modern eras and their influence on music today",
      "Important technique and practice drills",
      "Tips to play famous pieces: “Prelude in C”, “Moonlight Sonata,” “Clair de Lune,” and more"],
    recommendedPreparation: ["No prior musical knowledge needed to understand the video lessons", "Playing the song examples requires Intermediate level experience"],
  },
  231: {
    id: 231,
    summary: `Part of our Community Challenge Series, this course teaches how to play a Rookie level arrangement of the beautiful holiday carol “Silent Night.”`,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    }],
    topics: ["A Rookie song arrangement of “Silent Night”"],
    recommendedPreparation: [`No prerequisites`, `Familiarity with the fingering system is helpful`, `Experience playing with both hands is helpful`],
  },
  232: {
    id: 232,
    summary: `Part of our Community Challenge Series, this course teaches how to play an Intermediate level arrangement of the beautiful holiday carol “Silent Night.”`,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    }],
    topics: ["An Intermediate song arrangement of “Silent Night”"],
    recommendedPreparation: [`How to play basic rhythms`, `Familiarity with playing block chords`],
  },
  237: {
    id: 237,
    summary: `A more advanced exploration of scales, this course delves into a wide variety of scales beyond the basics. Covering major and natural minor scales across 2 octaves, as well as harmonic minor, melodic minor, pentatonic, blues, whole tone, and chromatic scales. Practicing these scales will enhance your finger strength, dexterity, and overall technique, providing a solid foundation for all styles of music and helping you learn songs more quickly and efficiently. `,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true,
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    }],
    topics: ["How to play major and natural minor scales with both hands across 2 octaves", "How to play various advanced scales: harmonic minor, melodic minor, pentatonic, blues, whole tone, and chromatic", "Techniques to improve finger strength, dexterity, and overall musicality"],
    recommendedPreparation: [`How to play with both hands`, `How to play 1 octave major and minor scales`],
  },
  243: {
    id: 243,
    summary: `Part of our Community Challenge Series, this course offers a curated selection of exciting film and TV shorts designed to help you get back into the habit of regular piano practice. Released in September, when coming out of the summer break is a perfect time to refocus on your piano playing, these songs will inspire you to build consistent practice habits as the fall season begins. Whether you’ve taken some time off or found it hard to stay consistent, this course is the perfect way to get back into a regular practice routine. Specifically, the challenge is to practice at least 3 times a week while learning songs from this playlist.`,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: false,
    },
    organizationMethod: "Any order",
    topics: ["A selection of film and TV shorts arranged for rookie and intermediate levels"],
    recommendedPreparation: ["Basic note reading"],
  },
  244: {
    id: 244,
    summary: `As part of our Community Challenge Series, this course features an intermediate full-song arrangement of Die with a Smile, a top hit by Bruno Mars and Lady Gaga. Throughout October, we’ll release sections of the song over 17 days, with breaks in between to give you time to practice and catch up. Whether you're intermediate, advanced, or a rookie eager to learn chords or the right-hand melody, this challenge will guide you step by step through learning Die with a Smile. By the end of the month, the goal is to get as much of the song down as possible. Sometimes, taking on a full song is a great and rewarding challenge!`,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true,
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    }],
    topics: ["How to play Die with a Smile at an Intermediate level"],
    recommendedPreparation: ["How to play chords"]
  },
  246: {
    id: 246,
    summary: `The December 2024 Community Challenge is all about spreading holiday cheer through music! Like an advent calendar for pianists, each day for the first 12 days of December, we’ll unveil a new Holiday Play-Along and Short for Rookie, along with a Short for Intermediate. The challenge is simple: pick a song (or 2 or 3, etc.), practice at your own pace, and enjoy playing it during the holiday season. Whether you’re new to piano or building on your skills, this festive challenge is a fun and inspiring way to embrace the holiday spirit while improving your playing.`,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true,
    },
    organizationMethod: "Any order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    }],
    topics: ["How to play holiday classics at your skill level, with festive backing tracks", "Techniques to improve rhythm, timing, and musicality", "How to confidently play a song to share with friends and family"],
    recommendedPreparation: ["How to navigate basic Rookie or Intermediate songs", "How to use both hands while playing simple melodies or chords"],
  },
  252: {
    id: 252,
    summary: `As part of our Holiday Challenge Series, this course features a festive, Rookie-level arrangement of "Carol of the Bells". Starting December 1st 2025, we’ll release one new lesson per day for the first 11 days of December — giving you time to learn, practice, and enjoy this holiday favorite at your own pace. Whether you're just getting started or returning to the piano after a break, this challenge is a fun and rewarding way to celebrate the holiday season.`,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true,
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    }],
    topics: ['How to play "Carol of the Bells" at the Rookie level', 'How to play with both hands in time with a backing track', 'Holiday-themed rhythm and melodic patterns'],
    recommendedPreparation: ["Nothing is required, Phil is with you step-by-step."],
  },
  251: {
    id: 251,
    summary: `Celebrate the holiday season with this festive Intermediate-level arrangement of "Carol of the Bells", part of our 2025 Holiday Challenge Series. Beginning December 1st 2025, you’ll get access to one new lesson each day for the first 11 days of December. Phil will guide you through the piece step by step, helping you strengthen your rhythm, accuracy, and musicality through this iconic holiday classic.\n\nWhether you’re an intermediate or advanced player — or a Rookie looking to level up — this is the perfect seasonal challenge to stay motivated, improve your skills, and bring music to your December...`,
    lessonFeatures: {
      hasInteractiveNotation: true,
      hasVideo: true,
    },
    organizationMethod: "Sequential order",
    teachers: [{
      teacherImgUrl: philAnderson,
      teacherName: "Phil Anderson",
    }],
    topics: ['How to play "Carol of the Bells" at the Intermediate level', 'Hands-together coordination with block chord patterns', 'Playing in time with backing tracks and musical dynamics'],
    recommendedPreparation: ["How to play with both hands together", "Familiarity with playing chords"],
  },
};


export const getConfiguredCourseOverview = (courseId: number): ICourseOverview | undefined =>
  courseOverviewConfig[courseId];
